// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__EnNsI","productName":"Table_productName__1UrJT"};